import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PRECIOS_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function PreciosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PRECIOS_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
